// Arquivo complementar para funcionalidades adicionais do modal de personalização

// Adiciona estilos para o body quando o modal está aberto
document.addEventListener('DOMContentLoaded', function() {
  // CSS para scroll lock
  const style = document.createElement('style');
  style.textContent = `
    body.scroll-lock {
      overflow: hidden;
      position: fixed;
      width: 100%;
    }
  `;
  document.head.appendChild(style);
});

// Helper para formatar valores em moeda brasileira
function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
}

// Helper para validar arquivo de imagem
function validateImageFile(file) {
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  const maxSize = 32 * 1024 * 1024; // 32MB
  
  if (!validTypes.includes(file.type)) {
    return {
      valid: false,
      error: 'Por favor, envie apenas imagens (JPEG, PNG, GIF ou WebP)'
    };
  }
  
  if (file.size > maxSize) {
    return {
      valid: false,
      error: 'A imagem deve ter no máximo 32MB'
    };
  }
  
  return { valid: true };
}

// Helper para compactar imagem se necessário
async function compressImage(file, maxWidth = 1920, maxHeight = 1920, quality = 0.9) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // Calcula as novas dimensões mantendo a proporção
        if (width > height) {
          if (width > maxWidth) {
            height = height * (maxWidth / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = width * (maxHeight / height);
            height = maxHeight;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now()
          }));
        }, file.type, quality);
      };
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Exporta funções globais se necessário
window.personalizationHelpers = {
  formatCurrency,
  validateImageFile,
  compressImage
};